module.exports = __webpack_public_path__ + "static/img/hnlgy.1668468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hnlgy.png
// module id = a2TI
// module chunks = 1